import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Environment, IMail, INotificaSendMailModel } from '../../models/-index';

@Injectable()
export class MailerService {
  private env: Environment;
  constructor(private http: HttpClient, @Inject('ENV') environment: Environment) {
    this.env = environment;
  }

  Send(model: INotificaSendMailModel) {
    const url = this.env.apiUrl + '/api/Mailer';
    return this.http.post(`${url}`, model);
  }
  SendAnMail(mail: IMail) {
    const url = this.env.apiUrl + '/api/Mailer/SendAnMail';
    return this.http.post(`${url}`, mail);
  }
}
